/**
 * COPIA de goautos-admin src/components/builder2/i18n/defaultsPt.a.ts (mismo
 * contenido; si se cambia allá, copiarlo acá). En el sitio lo usa
 * builder2/utils/defaultsPt.ts para traducir al vuelo, solo en Brasil.
 *
 * Textos de fábrica del editor del sitio: español EXACTO (clave) → portugués de
 * Brasil (valor). Parte A: plantillas (templates/) y secciones initialfold/,
 * forms/, premium/, moderna/. Ver localizarDefaults.ts.
 *
 * Reglas de este mapa:
 * - La clave es el texto TAL CUAL está en el código (un acento o un punto de
 *   diferencia y no se traduce).
 * - Solo texto que se ve en el sitio. NUNCA valores que el código compara
 *   ('Publicado', 'Reservado', 'Vendido', 'Nuevo', 'Todos'...), ni números de
 *   las cifras ('2,000', '4.9': el sitio los anima con parseInt), ni nombres
 *   de componente / displayName.
 * - Textos que en portugués quedan iguales (Email, Marca, Modelo, Buscar,
 *   Empresa, Ver catálogo, Compra segura, Ver ofertas...) no llevan entrada.
 */
export const DEFAULTS_PT_A: Record<string, string> = {
  // ── Plantillas: navegación ──
  'Inicio': 'Início',
  'Financiamiento': 'Financiamento',
  'Consignaciones': 'Consignação',
  'Compra directa': 'Compra direta',
  'Buscamos por ti': 'Buscamos para você',
  'Contacto': 'Contato',

  // ── Plantillas: héroes y bloques de la portada ──
  'Encuentra tu próximo vehículo en': 'Encontre seu próximo veículo na',
  'Describe el vehículo de tus sueños y deja que nuestra IA encuentre las mejores opciones para ti.':
    'Descreva o veículo dos seus sonhos e deixe nossa IA encontrar as melhores opções para você.',
  'Toyota Corolla blanco': 'Toyota Corolla branco',
  'Ver Stock Completo': 'Ver Estoque Completo',
  'Explora nuestro stock': 'Explore nosso estoque',
  'Ver detalles': 'Ver detalhes',
  'Recién publicado': 'Recém-publicado',
  'Vehículos destacados': 'Veículos em destaque',
  'Descubre nuestra selección de vehículos': 'Descubra nossa seleção de veículos',
  '¿Cómo llegar?': 'Como chegar?',
  'Encuéntranos en la siguiente dirección:': 'Encontre-nos no seguinte endereço:',
  '¿Listo para encontrar tu auto ideal?': 'Pronto para encontrar seu carro ideal?',
  'Contáctanos hoy mismo': 'Fale conosco hoje mesmo',
  'Contáctanos': 'Fale conosco',
  'Lo que dicen nuestros clientes': 'O que dizem nossos clientes',
  'Preguntas Frecuentes': 'Perguntas Frequentes',
  'Preguntas frecuentes': 'Perguntas frequentes',
  'Resolvemos tus dudas': 'Tiramos suas dúvidas',
  'Conócenos en video': 'Conheça-nos em vídeo',
  'Descubre quiénes somos y qué nos hace diferentes.': 'Descubra quem somos e o que nos torna diferentes.',
  '¡Oferta especial este mes! Financiamiento desde 0% de interés':
    'Oferta especial deste mês! Financiamento com juros a partir de 0%',
  'Nuestra galería': 'Nossa galeria',
  'Nuestro equipo': 'Nossa equipe',
  'La mejor selección de vehículos con financiamiento a tu medida y atención personalizada.':
    'A melhor seleção de veículos com financiamento sob medida e atendimento personalizado.',
  'Ver vehículos': 'Ver veículos',
  '500+ autos vendidos': '500+ carros vendidos',
  '4.9★ en Google': '4,9★ no Google',
  'Financiamiento 100%': 'Financiamento 100%',
  'Garantía incluida': 'Garantia inclusa',
  'Experiencia automotriz': 'Experiência automotiva',
  'Vehículos seleccionados para quienes exigen lo extraordinario.':
    'Veículos selecionados para quem exige o extraordinário.',
  'Explorar vehículos': 'Explorar veículos',
  'Por qué elegirnos': 'Por que nos escolher',
  'Una experiencia premium en cada detalle': 'Uma experiência premium em cada detalhe',
  'Testimonios': 'Depoimentos',
  'Descubre nuestras instalaciones y vehículos destacados': 'Conheça nossas instalações e veículos em destaque',
  'Agenda tu visita exclusiva': 'Agende sua visita exclusiva',
  'Reserva una cita personalizada con uno de nuestros asesores.':
    'Reserve um atendimento personalizado com um de nossos consultores.',
  'Reservar ahora': 'Reservar agora',

  // ── Plantillas: héroe de cada subpágina (PAGE_HERO_CONTENT) ──
  'Financiamiento a tu Medida': 'Financiamento sob Medida',
  'Accede a las mejores opciones de crédito automotriz. Simula tu financiamiento y encuentra el plan perfecto para ti.':
    'Acesse as melhores opções de crédito automotivo. Simule seu financiamento e encontre o plano perfeito para você.',
  'Consigna tu Vehículo': 'Consigne seu Veículo',
  'Déjanos vender tu vehículo por ti. Nos encargamos de todo el proceso para que obtengas el mejor precio.':
    'Deixe a venda do seu veículo com a gente. Cuidamos de todo o processo para você conseguir o melhor preço.',
  'Compra Directa': 'Compra Direta',
  '¿Quieres vender tu vehículo de forma rápida y segura? Te hacemos una oferta justa al instante.':
    'Quer vender seu veículo de forma rápida e segura? Fazemos uma oferta justa na hora.',
  'Buscamos por Ti': 'Buscamos para Você',
  'Cuéntanos qué vehículo buscas y nuestro equipo se encargará de encontrarlo para ti.':
    'Conte qual veículo você procura e nossa equipe vai encontrá-lo para você.',
  'Estamos aquí para ayudarte. Envíanos un mensaje y te responderemos a la brevedad.':
    'Estamos aqui para ajudar. Envie uma mensagem e responderemos o mais breve possível.',
  'Nosotros': 'Quem Somos',
  'Conoce nuestra historia, nuestro equipo y lo que nos motiva cada día.':
    'Conheça nossa história, nossa equipe e o que nos motiva todos os dias.',
  'Agenda tu visita': 'Agende sua visita',
  'Reserva un horario para visitarnos y conocer nuestros vehículos.':
    'Reserve um horário para nos visitar e conhecer nossos veículos.',

  // ── Página Nosotros: valores y equipo ──
  'Nuestra Misión': 'Nossa Missão',
  'Ofrecer la mejor experiencia en compra y venta de vehículos, con transparencia y confianza en cada operación.':
    'Oferecer a melhor experiência em compra e venda de veículos, com transparência e confiança em cada negociação.',
  'Confianza': 'Confiança',
  'Nos destacamos por la honestidad y transparencia en cada transacción. Tu satisfacción es nuestra prioridad.':
    'Nos destacamos pela honestidade e transparência em cada transação. Sua satisfação é nossa prioridade.',
  'Excelencia': 'Excelência',
  'Mejora continua en nuestros procesos para garantizar un servicio de primer nivel a todos nuestros clientes.':
    'Melhoria contínua em nossos processos para garantir um serviço de primeira linha a todos os nossos clientes.',
  'Nuestro Equipo': 'Nossa Equipe',
  'Conoce a las personas detrás de nuestra automotora': 'Conheça as pessoas por trás da nossa concessionária',
  'Nombre del Gerente': 'Nome do Gerente',
  'Gerente General': 'Gerente Geral',
  'Nombre del Vendedor': 'Nome do Vendedor',
  'Ventas': 'Vendas',
  'Nombre del Asesor': 'Nome do Consultor',
  'Atención al Cliente': 'Atendimento ao Cliente',

  // ── Plantillas: secciones extra de las subpáginas ──
  '¿Por qué financiar con nosotros?': 'Por que financiar com a gente?',
  '¿Por qué consignar con nosotros?': 'Por que consignar com a gente?',
  '¿Por qué vendernos tu auto?': 'Por que vender seu carro para nós?',
  '¿Por qué elegirnos?': 'Por que nos escolher?',
  'Nuestros servicios': 'Nossos serviços',
  '¿Tienes dudas?': 'Tem dúvidas?',
  'Nuestro equipo está listo para ayudarte': 'Nossa equipe está pronta para ajudar você',
  'Nuestras ventajas': 'Nossas vantagens',
  'Financiamiento premium': 'Financiamento premium',
  'Servicio de consignación premium': 'Serviço de consignação premium',
  'Compra directa premium': 'Compra direta premium',
  'Búsqueda personalizada': 'Busca personalizada',
  'Experiencia premium': 'Experiência premium',
  'Lo que nos distingue': 'O que nos diferencia',
  '¿Listo para comenzar?': 'Pronto para começar?',
  'Contáctanos y descubre la diferencia': 'Fale conosco e descubra a diferença',
  'Hablar con un asesor': 'Falar com um consultor',
  '¿Necesitas ayuda?': 'Precisa de ajuda?',
  'Estamos a un mensaje de distancia': 'Estamos a uma mensagem de distância',

  // ── initialfold/ ──
  // HeroBasic (defaults de la firma; los de .craft vienen de clientDefaults)
  'Encuentra el auto ideal para ti': 'Encontre o carro ideal para você',
  'Amplio catálogo de vehículos seminuevos certificados con garantía y financiamiento a tu medida':
    'Amplo catálogo de veículos seminovos certificados, com garantia e financiamento sob medida',
  // HeroCarSearch / HeroSearchBanner
  'Encuentra tu auto ideal': 'Encontre seu carro ideal',
  'Busca entre miles de vehículos disponibles': 'Busque entre milhares de veículos disponíveis',
  'Miles de vehículos disponibles en toda la región': 'Milhares de veículos disponíveis em toda a região',
  'Año': 'Ano',
  'Precio': 'Preço',
  // HeroFeatureCards
  'Lo mejor para tu próximo auto': 'O melhor para o seu próximo carro',
  'Descubre por qué miles de personas eligen GoAuto para encontrar vehículos':
    'Descubra por que milhares de pessoas escolhem a GoAuto para encontrar veículos',
  'Financiamiento a tu medida': 'Financiamento sob medida',
  'Opciones flexibles de pago adaptadas a tu presupuesto y necesidades':
    'Opções flexíveis de pagamento adaptadas ao seu orçamento e às suas necessidades',
  'Amplio catálogo': 'Amplo catálogo',
  'Miles de vehículos nuevos y usados con toda la información que necesitas':
    'Milhares de veículos novos e seminovos com todas as informações de que você precisa',
  'Proceso rápido': 'Processo rápido',
  'Desde la búsqueda hasta la adquisición en tiempo récord': 'Da busca à compra em tempo recorde',
  'Garantía total': 'Garantia total',
  'Todos nuestros vehículos pasan por rigurosas inspecciones de calidad':
    'Todos os nossos veículos passam por rigorosas inspeções de qualidade',
  // HeroImageDivided
  'La mejor selección de autos seminuevos y nuevos': 'A melhor seleção de carros seminovos e novos',
  'Encuentra el vehículo perfecto para ti. Con miles de opciones disponibles, garantía extendida y financiamiento accesible, comprar tu próximo auto nunca fue tan fácil.':
    'Encontre o veículo perfeito para você. Com milhares de opções disponíveis, garantia estendida e financiamento acessível, comprar seu próximo carro nunca foi tão fácil.',
  'Solicitar cotización': 'Solicitar cotação',
  'Autos certificados': 'Carros certificados',
  'Todos nuestros vehículos son inspeccionados minuciosamente':
    'Todos os nossos veículos são inspecionados minuciosamente',
  'Garantía extendida': 'Garantia estendida',
  'Hasta 3 años de garantía en motor y transmisión': 'Até 3 anos de garantia de motor e câmbio',
  'Documentación verificada y proceso transparente': 'Documentação verificada e processo transparente',
  // HeroMega
  'Stock disponible': 'Estoque disponível',
  'Consignación': 'Consignação',
  'Compramos tu auto': 'Compramos seu carro',
  'Quiénes somos': 'Quem somos',
  'Encuentra tu': 'Encontre seu',
  'Próximo vehículo': 'Próximo veículo',
  // HeroMinimalistic (también los defaults de clientDefaults)
  'Descubre Tu Próximo Vehículo': 'Descubra Seu Próximo Veículo',
  'Explora nuestra selección premium de autos y encuentra el que se adapta a tu estilo de vida':
    'Explore nossa seleção premium de carros e encontre o que combina com seu estilo de vida',
  'Contactar': 'Entrar em contato',
  // HeroTestimonial
  'Lo que nuestros clientes dicen': 'O que nossos clientes dizem',
  'Miles de personas han encontrado su vehículo ideal con GoAuto':
    'Milhares de pessoas encontraram seu veículo ideal com a GoAuto',
  'Carlos Rodríguez': 'Carlos Oliveira',
  'Comprador Reciente': 'Comprador Recente',
  'Encontré mi auto soñado en menos de una semana. El proceso fue increíblemente sencillo y el financiamiento se ajustó perfectamente a mi presupuesto.':
    'Encontrei o carro dos meus sonhos em menos de uma semana. O processo foi incrivelmente simples e o financiamento coube perfeitamente no meu orçamento.',
  'Mariana López': 'Mariana Souza',
  'Cliente Satisfecha': 'Cliente Satisfeita',
  'La atención personalizada fue excepcional. Me ayudaron a entender todas mis opciones y encontré un vehículo que superó mis expectativas.':
    'O atendimento personalizado foi excepcional. Me ajudaram a entender todas as minhas opções e encontrei um veículo que superou minhas expectativas.',
  'Juan Méndez': 'João Mendes',
  'Padre de Familia': 'Pai de Família',
  'Necesitaba una camioneta familiar con excelentes condiciones y a buen precio. GoAuto me ofreció múltiples opciones que se ajustaban a mis necesidades.':
    'Eu precisava de um SUV familiar em ótimo estado e com bom preço. A GoAuto me ofereceu várias opções que atendiam às minhas necessidades.',
  // HeroWithBackground / HeroWithVideoEmbed
  'Encuentra tu próximo auto': 'Encontre seu próximo carro',
  'Amplio inventario de autos seminuevos verificados y con garantía':
    'Amplo estoque de carros seminovos verificados e com garantia',
  // HeroWithCard
  'GoAuto - Tu mejor opción': 'GoAuto - Sua melhor opção',
  'Encuentra el vehículo perfecto para ti': 'Encontre o veículo perfeito para você',
  'Financiamiento disponible': 'Financiamento disponível',
  'Ofrecemos las mejores opciones de financiamiento adaptadas a tus necesidades. Aprobación rápida y tasas competitivas.':
    'Oferecemos as melhores opções de financiamento adaptadas às suas necessidades. Aprovação rápida e taxas competitivas.',
  'Solicitar ahora': 'Solicitar agora',
  // HeroWithImage
  'Obtén tu auto seminuevo con opciones de financiamiento accesibles y aprobación rápida':
    'Tenha seu carro seminovo com opções de financiamento acessíveis e aprovação rápida',
  'Ver opciones': 'Ver opções',
  // HeroWithLogo (y companyName por defecto de clientDefaults)
  'Automotora': 'Concessionária',

  // ── forms/ ──
  '¿Quieres vender tu vehículo de forma rápida y segura? Te hacemos una oferta al instante.':
    'Quer vender seu veículo de forma rápida e segura? Fazemos uma oferta na hora.',
  'Accede a las mejores opciones de crédito automotriz con tasas competitivas y plazos flexibles.':
    'Acesse as melhores opções de crédito automotivo com taxas competitivas e prazos flexíveis.',
  'Cuéntanos qué vehículo buscas y nuestro equipo se encargará de encontrarlo.':
    'Conte qual veículo você procura e nossa equipe vai encontrá-lo.',
  // WeSearchFormEmbed: etiquetas de los campos por defecto (DEFAULT_FIELDS).
  // El sitio solo las muestra; el tipo de campo va en fieldType.
  'Nombre': 'Nome',
  'Apellido': 'Sobrenome',
  'Teléfono': 'Telefone',
  'Año desde': 'Ano a partir de',
  'Año hasta': 'Ano até',
  'Kilometraje máximo': 'Quilometragem máxima',
  'Presupuesto': 'Orçamento',
  'Mensaje': 'Mensagem',

  // ── premium/ ──
  'Reserva una cita personalizada con uno de nuestros asesores y vive la experiencia premium que mereces.':
    'Reserve um atendimento personalizado com um de nossos consultores e viva a experiência premium que você merece.',
  'Nos dedicamos a ofrecer el más alto estándar en cada paso del proceso.':
    'Nos dedicamos a oferecer o mais alto padrão em cada etapa do processo.',
  'Cada vehículo cuenta con cobertura completa respaldada por los mejores estándares de la industria.':
    'Cada veículo conta com cobertura completa, respaldada pelos melhores padrões do setor.',
  'Financiamiento flexible': 'Financiamento flexível',
  'Planes personalizados con las mejores tasas del mercado.': 'Planos personalizados com as melhores taxas do mercado.',
  'Atención 24/7': 'Atendimento 24/7',
  'Soporte dedicado cuando lo necesites, sin importar la hora.': 'Suporte dedicado quando você precisar, a qualquer hora.',
  'Certificación premium': 'Certificação premium',
  'Cada vehículo supera 150 puntos de inspección rigurosa.': 'Cada veículo é aprovado em uma inspeção rigorosa de 150 itens.',
  'Entrega a domicilio': 'Entrega em domicílio',
  'Tu vehículo llega directamente a tu puerta.': 'Seu veículo chega diretamente à sua porta.',
  'Asesor personal': 'Consultor pessoal',
  'Un experto dedicado exclusivamente a tu búsqueda.': 'Um especialista dedicado exclusivamente à sua busca.',
  // GalleryPremium: leyendas de las fotos de ejemplo (DEFAULT_IMAGES)
  'Deportivo de lujo': 'Esportivo de luxo',
  'Elegancia en movimiento': 'Elegância em movimento',
  'Potencia y diseño': 'Potência e design',
  'Clásico moderno': 'Clássico moderno',
  // TestimonialsPremium
  'Una experiencia de compra excepcional. Desde la primera consulta hasta la entrega, cada detalle fue impecable.':
    'Uma experiência de compra excepcional. Do primeiro contato à entrega, cada detalhe foi impecável.',
  'Carolina Vásquez': 'Carolina Ribeiro',
  'Empresaria': 'Empresária',
  'El nivel de profesionalismo y la calidad de los vehículos superaron mis expectativas. Sin duda volveré.':
    'O nível de profissionalismo e a qualidade dos veículos superaram minhas expectativas. Com certeza voltarei.',
  'Andrés Montero': 'André Monteiro',
  'Ingeniero': 'Engenheiro',
  'Financiamiento transparente y un servicio post-venta que realmente se preocupa. Los recomiendo completamente.':
    'Financiamento transparente e um pós-venda que realmente se importa. Recomendo totalmente.',
  'Isabel Fuentes': 'Isabela Fontes',
  'Arquitecta': 'Arquiteta',

  // ── moderna/ ──
  'Tu automotora de confianza': 'Sua concessionária de confiança',
  'Contáctanos hoy y descubre las mejores opciones de financiamiento disponibles para ti.':
    'Fale conosco hoje e descubra as melhores opções de financiamento disponíveis para você.',
  'Comenzar ahora': 'Começar agora',
  'Tu aliado de confianza en la compra de vehículos. Ofrecemos la mejor selección, financiamiento flexible y garantía en cada auto.':
    'Seu parceiro de confiança na compra de veículos. Oferecemos a melhor seleção, financiamento flexível e garantia em cada carro.',
  'Sobre nosotros': 'Sobre nós',
  'Servicios': 'Serviços',
  'Vehículos': 'Veículos',
  'Vehículos vendidos': 'Veículos vendidos',
  'Clientes satisfechos': 'Clientes satisfeitos',
  'Años de experiencia': 'Anos de experiência',
  'Rating en Google': 'Avaliação no Google',
  'Experiencias reales de quienes confiaron en nosotros': 'Experiências reais de quem confiou em nós',
  'Excelente experiencia de compra. El equipo fue muy profesional y encontré exactamente lo que buscaba en menos de una semana.':
    'Excelente experiência de compra. A equipe foi muito profissional e encontrei exatamente o que procurava em menos de uma semana.',
  'Carlos Méndez': 'Carlos Mendes',
  'El mejor servicio postventa que he tenido. Respuesta inmediata y soluciones reales a cada consulta que tuve.':
    'O melhor pós-venda que já tive. Resposta imediata e soluções reais para cada dúvida que tive.',
  'María González': 'Maria Gonçalves',
  'Financiamiento rápido y transparente. Me dieron las mejores condiciones del mercado sin letra chica.':
    'Financiamento rápido e transparente. Me deram as melhores condições do mercado, sem letras miúdas.',
};
